import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueLazyLoad from "vue3-lazyload";
import BackToTop from "vue-backtotop";
import VueSocialSharing from "vue-social-sharing";
import Notifications from "@kyvg/vue3-notification";
import CookieConsentVue from "./CookieConsentVue.js";
import ManualTrackerPlugin from "./plugins/manualTracker";
import "./plugins/axios";
import "./assets/styles/responsive.css";
import { setupCalendar } from "v-calendar";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faChevronLeft,
    faChevronRight,
    faEye,
    faCheck,
    faAngleDown,
    faStar,
    faMapMarker,
    faPhone,
    faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
// eslint-disable-next-line no-unused-vars
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import HighchartsVue from "highcharts-vue";
library.add(
    faChevronLeft,
    faChevronRight,
    faEye,
    faCheck,
    faAngleDown,
    faStar,
    faMapMarker,
    faPhone,
    faEnvelope,
);

createApp(App)
    .use(Notifications)
    .use(store)
    .use(router)
    .use(VueLazyLoad)
    .use(BackToTop)
    .use(VueSocialSharing)
    .use(CookieConsentVue)
    .use(ManualTrackerPlugin, { router })
    .use(setupCalendar, {})
    .use(HighchartsVue)
    .component("font-awesome-icon", FontAwesomeIcon)
    .mount("#app");
